export default __webpack_public_path__ + "static/media/CrasMonteAlegre.f8b8005a.jpg";